export enum GatewayType {
    WIRE_TRANSFER = 'WIRE_TRANSFER',
    PAYPAL = 'PAYPAL'
}

export interface OfflinePaymentInfo {
    country?: string;
    city?: string;
    modifiedAt?: string;
    bankAccountNo?: string;
    swiftCode?: string;
    vendorId?: string;
    epicAccountId?: string;
    bankName?: string;
    checkName?: string;
    accountStatus?: string;
    createdAt?: string;
    additionalAccountDetail?: string;
    pmtProviderUsrId?: string;
    pmtProviderUsrVerificationStatus?: string;
    classId?: string;
    gatewayType: GatewayType;
    statusReason?: string;
    foreignBank?: string;
    defaulted?: string;
    sellerProfileId?: string;
    pmtProviderUsrStatus?: string;
    transferMethod?: string;
    currency?: string;
    id?: string;
    lastClickHwSecureLinkAt?: string;
    bankBranch?: string;
    routingNo?: string;
    pmtProviderUsrCreatedOn?: string;
    bankType?: string;
    rvn?: number;
    clickHwSecureLinkCount?: string;
    accountEmail?: string;
    phoneNumber?: string;
    bankAccountType?: string;
    identityId?: string;
    series?: string;
}

export interface PayoutAccount {
    country: string;
    city: string;
    modifiedAt: string;
    bankAccountNo: string;
    swiftCode: string;
    vendorId: string;
    epicAccountId: string;
    bankName: string;
    checkName: string;
    accountStatus: string;
    createdAt: string;
    additionalAccountDetail: string;
    pmtProviderUsrId: string;
    pmtProviderUsrVerificationStatus: string;
    classId: string;
    gatewayType: GatewayType;
    statusReason: string;
    foreignBank: boolean;
    defaulted: boolean;
    sellerProfileId: string;
    pmtProviderUsrStatus: string;
    transferMethod: string;
    currency: string;
    id: string;
    lastClickHwSecureLinkAt: string;
    bankBranch: string;
    routingNo: string;
    pmtProviderUsrCreatedOn: string;
    bankType: string;
    rvn: number;
    clickHwSecureLinkCount: number;
    accountEmail: string;
    phoneNumber: string;
    bankAccountType: string;
    identityId: string;
    series: string;
}

export interface PayoutReportDetail {
    revenueEarnedYearToDate: number;
    esportEventEndTime: string;
    totalNumberOfPurchase: number;
    importedBy: string;
    createdAt: string;
    revenueEarnedThisPeriod: number;
    salesAmount: number;
    id: string;
    chargeBackAmount: number;
    offerTitle: string;
    refundAmount: number;
    sacCostAmount: number;
    gameId: string;
    period: string;
    reportId: string;
    withholdingAmount: number;
    revenueShare: number;
    esportWinningAccepted: boolean;
    prizeType: string;
    adjustedBaseRevenue: number;
    netUnitsSold: number;
    grossRevenue: number;
    shareAmount: number;
    namespaceDisplayName: string;
    esportEventId: string;
    namespace: string;
    offerId: string;
    basePayoutPrice: number;
    adjustment: number;
    totalNumberOfRefund: number;
    totalNumberOfChargeBack: number;
}

export interface PayoutReport {
    sacCostAmount: number;
    period: string;
    comments: string;
    withholdingAmount: number;
    revenueShare: number;
    revenueEarnedYearToDate: number;
    adjustedBaseRevenue: number;
    grossRevenue: number;
    sellerId: string;
    revenueEarnedThisPeriod: number;
    identityId: string;
    adjustment: number;
    details: PayoutReportDetail[];
    id: string;
}
